"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../../../context");
var ClientForm_1 = require("../../ClientForm");
var defaultClientTabs_1 = __importDefault(require("../../ClientForm/utils/defaultClientTabs"));
var Tabs_1 = require("../../Tabs");
var BehaviouralAdviceForm_1 = __importDefault(require("./Forms/BehaviouralAdviceForm"));
var BGETForm_1 = __importDefault(require("./Forms/BGETForm"));
var ClosingsForm_1 = __importDefault(require("./Forms/ClosingsForm"));
var FeedbackForm_1 = __importDefault(require("./Forms/FeedbackForm"));
var HeatingSystemForm_1 = __importDefault(require("./Forms/HeatingSystemForm"));
var HomeVisitForm_1 = __importDefault(require("./Forms/HomeVisitForm"));
var HotWaterForm_1 = __importDefault(require("./Forms/HotWaterForm"));
var OnwardReferralForm_1 = __importDefault(require("./Forms/OnwardReferralForm"));
var ProjectForm_1 = __importDefault(require("./Forms/ProjectForm"));
var ResidentForm_1 = __importDefault(require("./Forms/ResidentForm"));
var SmartMeterForm_1 = __importDefault(require("./Forms/SmartMeterForm"));
var WarmHomeForm_1 = __importDefault(require("./Forms/WarmHomeForm"));
var WaterSureForm_1 = __importDefault(require("./Forms/WaterSureForm"));
var WhiteGoodsForm_1 = __importDefault(require("./Forms/WhiteGoodsForm"));
var tabs_1 = __importDefault(require("./tabs"));
var ClientForm = function (props) {
    var trans = context_1.useSemantics().trans;
    var isBget = props.isBget, _a = props.onlyProject, onlyProject = _a === void 0 ? false : _a, rest = __rest(props, ["isBget", "onlyProject"]);
    var tabs = react_1.useMemo(function () { return __spreadArrays(defaultClientTabs_1.default(trans), tabs_1.default(trans, onlyProject, isBget)); }, [onlyProject]);
    return (react_1.default.createElement(ClientForm_1.ClientForm, __assign({}, rest, { tabs: tabs }),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.project" },
                react_1.default.createElement(ProjectForm_1.default, { tabId: "project.project" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.home-visit" },
                react_1.default.createElement(HomeVisitForm_1.default, { tabId: "project.home-visit" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.heating-system" },
                react_1.default.createElement(HeatingSystemForm_1.default, { tabId: "project.heating-system" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.hot-water" },
                react_1.default.createElement(HotWaterForm_1.default, { tabId: "project.hot-water" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.behavioural-advice" },
                react_1.default.createElement(BehaviouralAdviceForm_1.default, { tabId: "project.behavioural-advice" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.warm-home" },
                react_1.default.createElement(WarmHomeForm_1.default, { tabId: "project.warm-home" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.watersure" },
                react_1.default.createElement(WaterSureForm_1.default, { tabId: "project.watersure" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.white-goods" },
                react_1.default.createElement(WhiteGoodsForm_1.default, { tabId: "project.white-goods" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.smart-meter" },
                react_1.default.createElement(SmartMeterForm_1.default, { tabId: "project.smart-meter" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.onward-referral" },
                react_1.default.createElement(OnwardReferralForm_1.default, { tabId: "project.onward-referral" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.feedback" },
                react_1.default.createElement(FeedbackForm_1.default, { tabId: "project.feedback" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.closings" },
                react_1.default.createElement(ClosingsForm_1.default, { tabId: "project.closings" })),
            isBget && (react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.bget" },
                react_1.default.createElement(BGETForm_1.default, { tabId: "project.bget" }))),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "project.resident" },
                react_1.default.createElement(ResidentForm_1.default, { tabId: "project.resident" })))));
};
exports.default = ClientForm;
//# sourceMappingURL=ClientForm.js.map